import { setup as setupCookieConsent } from '../src/adapters/cookie-consent'
setupCookieConsent()

import '../src/setup/setup-public-path.ts'

import '../scss/index.scss'

import '../src/setup/on_dom_load'
import '../src/setup/expose-globally'
import '../src/setup/sentry-install'

import 'dropzone'
import _ from 'lodash'

import * as Turbo from '@hotwired/turbo'
Turbo.session.drive = false

// Lodash's UMD factory only sets window._ when no CommonJS module is detected.
// Rspack's module wrapper provides a CommonJS-like environment, so lodash exports
// via module.exports instead. Assign explicitly then call noConflict.
window._ = _
window._.noConflict()

import '../src/setup/setup-global-context'

import '../src/external/uikit/uikit-modal'
import '../src/external/uikit/uikit-tab'

import '../src/external/jquery'
import '../src/external/silverfin-carousel'
import '../src/setup/bootstrap'
import '../src/setup/event-hub'
import '../src/application/behaviors'
import '../src/application/admin'
import '../src/setup/console-log-monkey-patch'
import '../src/application/market'
import '../src/application/partner/partner-account-mapping-lists'
import '../src/application/partner/partner-template-filter'
import '../src/application/sf-ace'
import '../src/setup/favicon'
import '../src/setup/datadog-rum'
import '../src/setup/clickable'
import setupLibraries from '../src/setup'
import '../src/freshdesk'
import '../src/setup/navigation'
import '../src/setup/components'

export { Tooltip } from '../src/setup/tooltip/uikit-tooltip.ts'

import { globalMounter } from '../src/setup/global-components'
import globalComponents from '../src/shared/vue/global-components'
import setupWebComponents from '../src/shared/vue/global-components/web-components'

setupLibraries()
setupWebComponents()

globalMounter(onDomLoad)(globalComponents)
